import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TableRow } from './Table';
import { DragProvider } from './DragContext';

interface SortableTableRowProps {
  id: string;
  children: React.ReactNode;
  className?: string;
  isDragEnabled?: boolean;
}

const SortableTableRow: React.FC<SortableTableRowProps> = ({ 
  id, 
  children, 
  className = '',
  isDragEnabled = false 
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id,
    disabled: !isDragEnabled
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // If drag is not enabled, render a regular TableRow
  if (!isDragEnabled) {
    return (
      <TableRow className={className}>
        {children}
      </TableRow>
    );
  }

  // If drag is enabled, render a sortable TableRow but without listeners on the row itself
  // The listeners will be applied only to the drag handle via context
  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      className={className}
      {...attributes}
    >
      <DragProvider listeners={listeners}>
        {children}
      </DragProvider>
    </TableRow>
  );
};

export default SortableTableRow;